// src/components/LoadingSpinner.js

import React from 'react';

export default function LoadingSpinner() {
    return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '50vh', flexDirection: 'column' }}>
            <img 
                src="/glass-tool/loading.svg" 
                alt="Loading content..." 
                style={{ width: '80px', height: '80px', marginBottom: '15px' }} 
                onError={(e) => {
                    // Fail-safe fallback link if domain paths change
                    e.target.src = "https://test-api.stainedglassusa.com/uploads/loading.svg";
                }}
            />
            <h3 style={{ color: '#555', fontFamily: 'sans-serif' }}>Loading Pattern Data...</h3>
        </div>
    );
}